__turbopack_context__.v({
  "block": "paid-module-scss-module__jhAZpq__block",
  "buttonSimple": "paid-module-scss-module__jhAZpq__buttonSimple",
  "buttonSimple1": "paid-module-scss-module__jhAZpq__buttonSimple1",
  "buttongroup": "paid-module-scss-module__jhAZpq__buttongroup",
  "contactUs": "paid-module-scss-module__jhAZpq__contactUs",
  "goToHomepage": "paid-module-scss-module__jhAZpq__goToHomepage",
  "logoIcon": "paid-module-scss-module__jhAZpq__logoIcon",
  "name": "paid-module-scss-module__jhAZpq__name",
  "name1": "paid-module-scss-module__jhAZpq__name1",
  "paid": "paid-module-scss-module__jhAZpq__paid",
  "paid1440px": "paid-module-scss-module__jhAZpq__paid1440px",
  "text": "paid-module-scss-module__jhAZpq__text",
});
